import { ConditionalShopTileBlock, TsicommonCms5 } from "@reactivated";

import { InternalProduct } from "../../models/catalogue";

export const ATTRIBUTE_CLASSES = {
    soft: "Soft",
    medium: "Medium",
    hybrid: "Medium Hybrid",
    firm: "Firm",
} as const;

export type FeelAttributesType =
    (typeof ATTRIBUTE_CLASSES)[keyof typeof ATTRIBUTE_CLASSES];

// Abstract shared type for common product tile fields
export type AbstractProductTileData = {
    price: InternalProduct["price"];
    num_reviews: InternalProduct["num_reviews"];
    link: InternalProduct["link"];
    rating: InternalProduct["rating"];
    feel_options: FeelAttributesType[];
    size_options: string[];
    size_price_map?: Record<string, InternalProduct["price"]>;
    children?: InternalProduct[];
};

export type CompareTileType = TsicommonCms5 & AbstractProductTileData;

export type ShopTileType = ConditionalShopTileBlock & {
    shop_tile: ConditionalShopTileBlock["shop_tile"] & AbstractProductTileData;
};
